const a = {
  id: "ArkansasCash4",
  name: "Cash 4",
  style: {
    colorPrimary: "#9bca4b"
  }
};
export {
  a as default
};
